import createAction from 'redux-actions/es/createAction';

export const resetPasswordRequest = createAction('RESET_PASSWORD_REQUEST');
export const resetPasswordSuccess = createAction('RESET_PASSWORD_SUCCESS');
export const resetPasswordFail = createAction('RESET_PASSWORD_FAIL');
